import React, { useContext, useEffect, useState } from 'react'
import style from '../styles/register.module.css'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import Loading from '../components/Loading';
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import axios from 'axios';



const Login = () => {

    const { user, StoreToken, verifyUser, user_verified } = useContext(UserContext)
    const { setLoading } = useContext(StateContext)
    const [formData, setFormData] = useState({ text: "", password: "" });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
        setError('')
    }

    const token = localStorage.getItem("token")

    const verifyAndRedirect = async () => {
        setLoading({ open: true, text: 'Verifying...' });

        const result = await verifyUser(); // Call the function from context
        if (result?.success) {
            if (user?.verified === false) {
                navigate('/'); // Redirect if the user is not verified
            } else {
                if(user?.role === "agency"){
                    navigate('/dashboard/support')
                }else{
                    navigate('/dashboard'); // Redirect if the user is not verified
                }
            }
        } else {
            toast.error("Verification failed. Redirecting to login.");
            navigate('/'); // Redirect on failure
        }

        setLoading({ open: false, text: '' });
    };

    useEffect(() => {
        if(token){
            verifyAndRedirect();
        }
    }, []);
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        StoreToken();
        try {
            setLoading({ open: true, text: 'Verifying...' })
            const response = await fetch(process.env.REACT_APP_API_URL + "api/auth/login", {
                method: 'POST',
                headers: {
                    'Content-type': "application/json"
                },
                body: JSON.stringify(formData)
            })

            const json = await response.json();
            
            if (json.success) {
                if (json.user.verified == true) {
                    localStorage.setItem("token", json.authtoken)
                    if(json.role && json.role === "agency"){
                        navigate('/dashboard/support')
                    }else{
                        navigate('/dashboard')
                    }
                    toast.success("Login Successfully")
                } else {
                    toast.error("You are not Verified")
                }
            } else {
                console.log(json);
                // setError(json.error || json.message || json.message[0].msg)
                if(json.error){
                    setError(json.error)
                }else{
                    setError(json.message[0].msg);
                }
            }


        } catch (error) {
            console.log(error);
            // setError(error.response.data.error || error.response.data.message || error.response.data.message[0].msg)
            setError("Internal Server Error")
        } finally {
            setLoading({ open: false, text: '' })
        }
    }





    return (
        <>
            <div className={`container-fluid ${style.register} py-4`}>
                <div className="row">
                    <div className="col-lg-7 col-12 d-flex justify-content-center align-items-center flex-column">
                        <div className={`"container-fluid" ${style.box}`}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h1 className="text-center">Login</h1>
                                    <div className={style.formstart}>
                                        <form className={style.signup_form} onSubmit={handleSubmit}>
                                            <Loading />
                                            <div className={style.inputField}>
                                                <i className='bx bx-envelope' ></i>
                                                <input type="text" id="email" name='text' onChange={handleChange} placeholder="Username or Email" required />
                                            </div>
                                            <div className={style.inputField}>
                                                <i className='bx bx-lock-alt' ></i>
                                                <input type="password" id="password" name='password' onChange={handleChange} placeholder="Password" className="mb-0" required />
                                            </div>
                                            <p style={{ color: "red", marginBottom: "0px" }}>{error}</p>
                                            {/* <h5 className={`${style.signin} mb-0`}><Link to="/forgot">Forgot Password?</Link></h5> */}
                                            <button type="submit" className={`"btn btn-block mt-0" ${style.bttn1}`} style={{ marginTop: "0px !important" }} >Login</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12"></div>
                </div>

            </div>
        </>
    )
}

export default Login
